/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ContractDataUsageReportResponseDTO } from '../model/models';
import { ReportStatusDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GenerateArchivingReportDataContractRequestParams {
    usageYear: string;
    archivingContractId: string;
}

export class ClsGenerateArchivingReportDataContractRequestParams {
    usageYear: string = undefined;
    archivingContractId: string = undefined;
}

export interface GetArchivingCsvReportDataContractRequestParams {
    usageYear: string;
    archivingContractId: string;
}

export class ClsGetArchivingCsvReportDataContractRequestParams {
    usageYear: string = undefined;
    archivingContractId: string = undefined;
}

export interface GetArchivingReportDataContractRequestParams {
    usageYear: string;
    archivingContractId: string;
}

export class ClsGetArchivingReportDataContractRequestParams {
    usageYear: string = undefined;
    archivingContractId: string = undefined;
}

export interface GetReportStatusReportDataContractRequestParams {
    usageYear: string;
    archivingContractId: string;
}

export class ClsGetReportStatusReportDataContractRequestParams {
    usageYear: string = undefined;
    archivingContractId: string = undefined;
}


export interface AdminArchivingReportDataApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Generate an archiving usage data report with archived and downloaded space for the archiving contract.
     * This function will generate archiving usage data report with archived and downloaded space for the archiving contract. 
* @param requestParameters
     */
    generateArchivingReportDataContract(requestParameters: GenerateArchivingReportDataContractRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Download the generated archiving usage data CSV report with archived and downloaded space for the archiving contract
     * Download the generated archiving usage data CSV report with archived and downloaded space for the archiving contract. 
* @param requestParameters
     */
    getArchivingCsvReportDataContract(requestParameters: GetArchivingCsvReportDataContractRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Download the generated archiving usage data report with archived and downloaded space for the archiving contract
     * Download the generated archiving usage data report with archived and downloaded space for the archiving contract. 
* @param requestParameters
     */
    getArchivingReportDataContract(requestParameters: GetArchivingReportDataContractRequestParams, extraHttpRequestParams?: any): Observable<ContractDataUsageReportResponseDTO>;

    /**
     * Status of generating an archiving usage data with archived and downloaded space report.
     * Status of generating an archiving usage data report with archived and downloaded space for the archiving contract. 
* @param requestParameters
     */
    getReportStatusReportDataContract(requestParameters: GetReportStatusReportDataContractRequestParams, extraHttpRequestParams?: any): Observable<ReportStatusDTO>;

}
